export const IDS = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    basic: "nav-basic-track",
    advanced: "nav-advanced-track",
    donate: "nav-donate",
    games: "nav-games",
  },
  hero: {
    root: "hero-section",
    ctaBasic: "hero-cta-basic",
    ctaAdvanced: "hero-cta-advanced",
  },
  tracks: {
    basicCard: "track-card-basic",
    advancedCard: "track-card-advanced",
    startBasic: "track-start-basic",
    startAdvanced: "track-start-advanced",
  },
  lesson: {
    card: (id) => `lesson-card-${id}`,
    playSound: (id) => `lesson-play-sound-${id}`,
    playWord: (id) => `lesson-play-word-${id}`,
  },
  donation: {
    root: "donation-section",
    input: "donation-amount-input",
    button: "donation-submit-button",
    error: "donation-error",
  },
  games: {
    root: "games-section",
    launcher: (name) => `game-launcher-${name}`,
    close: "game-close",
    match: {
      option: (i) => `match-option-${i}`,
      playSound: "match-play-sound",
      score: "match-score",
      next: "match-next",
    },
    build: {
      letter: (i) => `build-letter-${i}`,
      slot: (i) => `build-slot-${i}`,
      submit: "build-submit",
      reset: "build-reset",
      score: "build-score",
      next: "build-next",
    },
    picture: {
      option: (i) => `picture-option-${i}`,
      score: "picture-score",
      next: "picture-next",
    },
    blend: {
      phoneme: (i) => `blend-phoneme-${i}`,
      playPhonemes: "blend-play-phonemes",
      playBlended: "blend-play-blended",
      reveal: "blend-reveal",
      next: "blend-next",
      word: "blend-word",
    },
  },
  donationSuccess: {
    root: "donation-success",
    home: "donation-success-home",
    status: "donation-success-status",
  },
};
